// Module
var code = "<div class=\"FieldSecurity\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"icon-lock\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;